import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { SuggestionEngineService } from '../suggestion-engine/suggestion-engine.service';
import { SessionStorageService } from '../services/session-storage.service';
import { UtilityAppsService } from '../shared-components/utility-apps/utility-apps.service';
import { Router } from '@angular/router';
import { dashboardLinks } from '../lib/toolbar-links';
import { dashboardUtilityApps } from '../lib/utility-apps';

import { SystemUsageTabComponent } from './system-usage-tab/system-usage-tab.component';
import { RecommendedProductsTabComponent } from './recommended-products/recommended-products-tab.component';
import { ScoreclassTabComponent } from './scoreclass-tab/scoreclass-tab.component';
import { SeDashboardComponent } from './se-dashboard/se-dashboard.component';
import { UtilityToolbarComponent } from '../shared-components/utility-toolbar/utility-toolbar.component';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    SystemUsageTabComponent,
    RecommendedProductsTabComponent,
    ScoreclassTabComponent,
    SeDashboardComponent,
    UtilityToolbarComponent,
    CommonModule,
    MatTabsModule,
  ],
})
export class DashboardComponent implements OnInit, OnDestroy {
  private route = inject(Router);
  private ses = inject(SuggestionEngineService);
  private ss = inject(SessionStorageService);
  private uas = inject(UtilityAppsService);

  app = this.ss.get('currentApp');
  solutions = [{ label: 'All', value: 'ALL' }];
  rights = this.ss.get('rights');
  navCollapsed = false;
  dashboardLinks = dashboardLinks;

  ngOnInit() {
    this.navCollapsed = this.ss.get('utilityToolbarCollapsed');
    this.ss.get('globals')?.Modules.forEach(el => {
      switch (el.toLowerCase()) {
        case 'aw':
          this.solutions.push({
            label: 'Annuity Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'iw':
          this.solutions.push({
            label: 'Investment Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'li':
          this.solutions.push({
            label: 'Life Insurance Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'pp':
          this.solutions.push({
            label: 'Product Profiler',
            value: el.toLowerCase(),
          });
          break;
        default:
          break;
      }
    });

    this.uas.appsList.set(dashboardUtilityApps);
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  toggleNavCollapse() {
    this.navCollapsed = !this.navCollapsed;
  }
}
